import axios from 'axios';
import URLs from '@/config/constants';

// eslint-disable-next-line import/prefer-default-export
export const postCreateBeneficiary = async ({ token, ...payload }) => axios.post(
  URLs.PostCreateBeneficiary,
  payload,
  {
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: token,
    },
  },
).then((resp) => {
  if (resp.status === 201) { return Promise.resolve(resp); }
  const responde = { response: { status: resp.status } };
  return Promise.reject(responde);
}).catch((resp) => {
  const responde = { response: { status: resp.response.status } };
  return Promise.reject(responde);
});
